import { SEVERITY_ORDER } from './severity';
import brand from '../shell/brand';

export const normalizeIssues = (payload) => {
  if (!Array.isArray(payload) || payload.some((item) => !item || item.id == null
    || !SEVERITY_ORDER.includes(item.severity)
    || !['NEW', 'RAISED', 'ACKNOWLEDGED', 'RESOLVED'].includes(item.status))) {
    throw new Error(`${brand.assistant} returned an invalid issue list.`);
  }
  return payload.map((item) => ({
    ...item,
    status: item.status === 'NEW' ? 'RAISED' : item.status,
    deviceId: item.deviceId ?? item.device_id,
    evidence: item.evidence && typeof item.evidence === 'object' ? item.evidence : {},
  }));
};

// When an exception happened, as opposed to when the system got round to recording it.
export const occurredAt = (issue) => issue.occurredAt || issue.raisedAt;

// How long it has been outstanding, in the units a desk talks in: minutes for the last hour, then
// hours, then days. Shared because the dashboard, the list and the drawer must not disagree.
export const ageLabel = (value) => {
  const milliseconds = Date.now() - Date.parse(value || '');
  if (!Number.isFinite(milliseconds) || milliseconds < 0) return 'Unknown';
  const minutes = Math.floor(milliseconds / 60000);
  if (minutes < 60) return `${minutes} min`;
  const hours = Math.floor(minutes / 60);
  if (hours < 48) return `${hours} h`;
  return `${Math.floor(hours / 24)} d`;
};

export const openIssues = (items) => items.filter((item) => item.status !== 'RESOLVED')
  .sort((a, b) => SEVERITY_ORDER.indexOf(a.severity) - SEVERITY_ORDER.indexOf(b.severity)
    || (Date.parse(a.raisedAt || a.created_at) || 0) - (Date.parse(b.raisedAt || b.created_at) || 0)
    || String(a.id).localeCompare(String(b.id)));

export const urgentIssues = (items) => openIssues(items)
  .filter((item) => ['CRITICAL', 'HIGH'].includes(item.severity));
